import axios from "@/plugins/axios"
import type { SignIn } from "@/types/common.type"
import type { Dashboard } from "@/types/dashboard.type"
import type { Notification, Partner } from "@/types/partner.type"

export interface SignInRequset {
  partnerId: string
  password: string
}

export interface UpdateNotificationRequest {
  phones: string[]
  emails: string[]
}

async function signIn(request: SignInRequset): Promise<SignIn> {
  const response = await axios.post<SignIn>("/partners/signin", request)
  return response.data
}

async function dashboard(): Promise<Dashboard> {
  const response = await axios.get("/partners/dashboard")
  return response.data
}

async function me(): Promise<Partner> {
  const response = await axios.get("/partners/me")
  return response.data
}

async function notification(): Promise<Notification> {
  const response = await axios.get("/partners/me/notification")
  return response.data
}

async function updateNotification(request: UpdateNotificationRequest): Promise<Notification> {
  const response = await axios.put("/partners/me/notification", request)
  return response.data
}

const partnerService = {
  signIn,
  dashboard,
  me,
  notification,
  updateNotification,
}

export default partnerService
